import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Eye, EyeOff, LogIn, UserPlus, AlertCircle, Loader2 } from 'lucide-react';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/mitgliederbereich', { replace: true });
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-icon-wrap">
              <LogIn className="login-icon" />
            </div>
            <h1>Anmelden</h1>
            <p>Melde dich im Mitgliederbereich an</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
            {error && (
              <div className="form-error" data-testid="login-error">
                <AlertCircle size={18} />
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">E-Mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.com"
                required
                disabled={loading}
                data-testid="login-email-input"
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Passwort</label>
              <div className="password-input-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Dein Passwort"
                  required
                  disabled={loading}
                  data-testid="login-password-input"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  data-testid="login-password-toggle"
                  aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              <Link to="/passwort-vergessen" className="forgot-password-link" data-testid="forgot-password-link">Passwort vergessen?</Link>
            </div>

            <button
              type="submit"
              className="btn-login"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? (
                <><Loader2 size={18} className="spin" /> Anmelden...</>
              ) : (
                <><LogIn size={18} /> Anmelden</>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Noch kein Konto?</p>
            <Link to="/registrieren" className="register-link" data-testid="register-link">
              <UserPlus size={16} />
              <span>Jetzt registrieren</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
